import { render, staticRenderFns } from "./SignupWizardStepSetName.vue?vue&type=template&id=6275ceed&scoped=true&"
import script from "./SignupWizardStepSetName.vue?vue&type=script&lang=js&"
export * from "./SignupWizardStepSetName.vue?vue&type=script&lang=js&"
import style0 from "./SignupWizardStepSetName.vue?vue&type=style&index=0&id=6275ceed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6275ceed",
  null
  
)

export default component.exports